<p-toast></p-toast>
<app-worker-dialog [useDialog]="true" [(visible)]="showWorkerDialog" [mode]="workerDialogMode" [data]="workerDialogData"
    [phonePrefixes]="phonePrefixes" (saved)="onWorkerSaved($event)" (closed)="onWorkerClosed()"></app-worker-dialog>
<div class="card" style="overflow-x: auto;">
    <div class="flex flex-column lg:flex-row lg:justify-content-between lg:align-items-center gap-3 p-3">
        <div class="p-text-center p-mb-2 lg:mb-0">
            {{ translateServ.dictionary['ITEM_WORKERS_MANG'] }}
        </div>
        <div class="flex flex-column lg:flex-row lg:justify-content-between lg:align-items-center gap-3 p-3">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="globalFilter" (input)="onGlobalFilter($event, dt)"
                    [placeholder]="translateServ.dictionary['GLOBAL_SEARCH']" class="p-inputtext-sm" />
            </span>
            <button pButton type="button" icon="pi pi-times" class="p-button-outlined p-button-sm"
                (click)="clearFilters(dt)" [pTooltip]="translateServ.dictionary['TOOLTIP_CLEAR_FILTER']"
                tooltipPosition="bottom"></button>
            <button pButton icon="pi pi-plus" (click)="openCreateWorkerDialog()" class="p-button-outlined p-button-sm">
                {{ translateServ.dictionary['CREATE_WORKER']}}
            </button>
            <button pButton type="button" icon="pi pi-refresh" class="p-button-outlined p-button-sm"
                (click)="reloadData()" [pTooltip]="translateServ.dictionary['REFRESH']"
                tooltipPosition="bottom"></button>
        </div>
    </div>

    <p-table 
        id = "tab_worker_info" #dt
        styleClass="app-data-table app-data-table--paged"
        dataKey="UserRecID"
        [value]="filteredWorkers"
        [paginator]="true"
        [totalRecords] = "filteredWorkers.length"
        [rows]="getCurrentPageSize(0,filteredWorkers.length)"
        responsiveLayout="scroll"
        [rowsPerPageOptions]="setPaginator(filteredWorkers.length)"
        [tableStyle]="{'min-width': '1000px'}"
        [filterDelay]="0"
        (onPage) = "onRowsPerPageChange($event, 0, filteredWorkers.length)"
        [paginatorDropdownAppendTo]="'body'"
        [expandedRowKeys]="expandedRows">

        <ng-template pTemplate="caption">
            <div class="flex flex-wrap justify-content-end align-items-center gap-2 px-2">
                <p-dropdown [options]="statusOptions" [(ngModel)]="statusFilter" optionLabel="label" optionValue="value"
                    [placeholder]="translateServ.dictionary['FILTER_BY_STATUS_PLACEHOLDER'] || 'Filter by Status'"
                    [showClear]="true" (onChange)="onStatusFilterChange(dt)" styleClass="p-dropdown-sm"></p-dropdown>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <th pSortableColumn="UserRecID">{{ translateServ.dictionary['JMT_COL_ID'] }}<p-sortIcon
                        field="UserRecID"></p-sortIcon>
                    <p-columnFilter type="numeric" field="UserRecID" display="menu"></p-columnFilter>
                </th>
                <th pSortableColumn="UserName">{{ translateServ.dictionary['USER_NAME'] }}<p-sortIcon
                        field="UserName"></p-sortIcon>
                    <p-columnFilter type="text" field="UserName" display="menu"></p-columnFilter>
                </th>
                <th pSortableColumn="FirstName">{{ translateServ.dictionary['FIRST_NAME'] }}<p-sortIcon
                        field="FirstName"></p-sortIcon>
                    <p-columnFilter type="text" field="FirstName" display="menu"></p-columnFilter>
                </th>
                <th pSortableColumn="LastName">{{ translateServ.dictionary['LAST_NAME'] }}<p-sortIcon
                        field="LastName"></p-sortIcon>
                    <p-columnFilter type="text" field="LastName" display="menu"></p-columnFilter>
                </th>
                <th pSortableColumn="Role">{{ translateServ.dictionary['POSITION'] }}<p-sortIcon
                        field="Role"></p-sortIcon>
                    <p-columnFilter type="text" field="Role" display="menu"></p-columnFilter>
                </th>
                <th pSortableColumn="Phones">{{ translateServ.dictionary['STEP_PHONES_TITLE'] }}<p-sortIcon
                        field="Phones"></p-sortIcon>
                    <p-columnFilter type="text" field="Phones" display="menu"></p-columnFilter>
                </th>
                <th pSortableColumn="Emails">{{ translateServ.dictionary['MAINT_CS_TAB_EMAILS'] }}<p-sortIcon
                        field="Emails"></p-sortIcon>
                    <p-columnFilter type="text" field="Emails" display="menu"></p-columnFilter>
                </th>
                <th pSortableColumn="Descr">{{ translateServ.dictionary['DESCRIPTION'] }}<p-sortIcon
                        field="Descr"></p-sortIcon>
                    <p-columnFilter type="text" field="Descr" display="menu"></p-columnFilter>
                </th>
                <th>{{ translateServ.dictionary['MAINT_CS_TIT_ACT_STAT'] }}</th>
                <th>{{ translateServ.dictionary['IS_CONNECTED'] }}</th>
                <th>{{ translateServ.dictionary['STEP_TAB_TIT_ACT'] }}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-worker>
            <tr>
                <td style="width: 4rem; text-align: center;">
                    <button type="button" class="p-button p-component p-button-text p-button-sm p-button-rounded"
                        (click)="$event.stopPropagation(); toggleRow(worker)" style="width: 2rem; height: 2rem;">
                        <i class="pi"
                            [ngClass]="isRowExpanded(worker) ? 'pi-chevron-down' : (dirServ.isRtl() ? 'pi-chevron-left' : 'pi-chevron-right')"
                            style="font-size: 0.8rem;"></i>
                    </button>
                </td>
                <td>{{ worker.UserRecID }}</td>
                <td>{{ worker.UserName }}</td>
                <td>{{ worker.FirstName }}</td>
                <td>{{ worker.LastName }}</td>
                <td>
                    <p-tag [value]="worker.Role" [severity]="worker.RoleColor"></p-tag>
                </td>
                <td>{{ worker.Phones }}</td>
                <td>{{ worker.Emails }}</td>
                <td>{{ worker.Descr }}</td>
                <td>
                    <span *ngIf="worker.IsActive == 1 || worker.IsActive === '1'; else notActive">
                        <span class="p-tag p-tag-success">{{ translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT']
                            }}</span>
                    </span>
                    <ng-template #notActive>
                        <span class="p-tag p-tag-danger">{{ translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT']
                            }}</span>
                    </ng-template>
                </td>
                <td>
                    <i class="pi pi-wifi"
                        [ngClass]="(worker.IsLogIn == 1 || worker.IsLogIn === '1') ? 'color-success' : 'color-danger'"
                        style="font-size: 1.2em;"></i>
                </td>
                <td style="text-align: center;">
                    <button pButton type="button" class="p-button-text p-button-sm"
                        (click)="openEditWorkerDialog(worker)">
                        <i [ngClass]="'pi pi-pencil'" class="mr-2"></i>
                    </button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-worker>
            <tr>
                <td [attr.colspan]="12" class="app-expanded-table-cell" style="padding:0;">
                    <p-tabView>
                        <p-tabPanel [header]="translateServ.dictionary['ASSIGNED_CUSTOMERS'] || 'Assigned Customers'">
                            <ng-container *ngIf="loadingCustomers[worker.UserRecID]">
                                <p-progressSpinner styleClass="mr-2" strokeWidth="4" fill="#EEEEEE"
                                    animationDuration=".5s"></p-progressSpinner>
                            </ng-container>
                            <ng-container *ngIf="!loadingCustomers[worker.UserRecID]">
                                <ng-container
                                    *ngIf="(customersMap[worker.UserRecID] ?? []).length > 0; else noCustomers">
                                    <p-table 
                                        id = "tab_worker_asg"
                                        styleClass="app-data-table app-data-table--compact app-data-table--paged"
                                        [value]="customersMap[worker.UserRecID]"
                                        [paginator]="true"
                                        [totalRecords] = "customersMap[worker.UserRecID].length"
                                        [rows]="getCurrentPageSize(1, customersMap[worker.UserRecID].length)"
                                        [rowsPerPageOptions]="setPaginator(customersMap[worker.UserRecID].length)"
                                        [tableStyle]="{'width': '100%'}"
                                        (onPage) = "onRowsPerPageChange($event, 1, customersMap[worker.UserRecID].length)"
                                        [paginatorDropdownAppendTo]="'body'"
                                        responsiveLayout="scroll">
                                        <ng-template pTemplate="header">
            <tr>
                <th>{{ translateServ.dictionary['JMT_COL_ID']}}</th>
                <th>{{ translateServ.dictionary['STEP_BASIC_BUSS_NAME_TITLE']}}</th>
                <th>{{ translateServ.dictionary['MAINT_CS_TIT_BUS_ID']}}</th>
                <th style="width: 14rem; text-align: center;">{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS']}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer>
            <tr>
                <td>{{ customer.id }}</td>
                <td>{{ customer.name }}</td>
                <td>{{ customer.businessId }}</td>
                <td style="text-align: center;">
                    <ng-container *ngIf="!showAssignInput[worker.UserRecID + '_' + (customer.userCustomerRecID ?? customer.UserCustomerRecID ?? customer.id)]; else assignInput">
                        <button pButton type="button" icon="pi pi-address-book" class="p-button-text p-button-sm"
                            (click)="openAssignInput(worker.UserRecID, customer)" pTooltip="Assign to other worker" tooltipPosition="top"></button>
                    </ng-container>
                    <ng-template #assignInput>
                        <div style="display:flex; align-items:center; gap:0.5rem;">
                            <p-autoComplete [(ngModel)]="selectedAssignWorker[worker.UserRecID + '_' + (customer.userCustomerRecID ?? customer.UserCustomerRecID ?? customer.id)]"
                                [suggestions]="assignSuggestions" (completeMethod)="filterAssign($event)"
                                field="label" [forceSelection]="true" [dropdown]="true" appendTo="body"
                                [style]="{width: '18rem'}"
                                placeholder="{{ translateServ.dictionary['ASSIGN_TO_WORKER'] || 'Assign to worker' }}"></p-autoComplete>
                            <button pButton type="button" icon="pi pi-check" class="p-button-text p-button-sm"
                                (click)="onConfirmAssign(worker.UserRecID, customer)"
                                [disabled]="!selectedAssignWorker[worker.UserRecID + '_' + (customer.userCustomerRecID ?? customer.UserCustomerRecID ?? customer.id)]"></button>
                            <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-sm" (click)="cancelAssignInput(worker.UserRecID, customer)"></button>
                        </div>
                    </ng-template>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" class="text-center p-4">{{ translateServ.dictionary['NO_ASSIGNED_CUSTOMERS'] || 'No
                    assigned customers.' }}</td>
            </tr>
        </ng-template>
    </p-table>
    <ng-template let-item pTemplate="paginatordropdownitem">
        {{ (item && (item.value !== undefined)) ? (item.value === filteredWorkers.length ? 'All' : item.value) : item }}
    </ng-template>
    </ng-container>
    <ng-template #noCustomers>
        <span>{{ translateServ.dictionary['NO_ASSIGNED_CUSTOMERS'] || 'No assigned customers.' }}</span>
    </ng-template>
    </ng-container>
    </p-tabPanel>

    <p-tabPanel [header]="translateServ.dictionary['WORKERS_CONTACTS'] || 'Worker\'s Contacts'">
        <div style="padding: 1rem;">
            <div style="display: flex; align-items: center; justify-content: flex-end; margin-bottom: 1rem;">
                <button pButton type="button" icon="pi pi-plus" class="p-button-outlined p-button-sm"
                    (click)="onCreateContact(worker, activeContactTabIndex)">
                    {{ activeContactTabIndex === 0 ? (translateServ.dictionary['CREATE_PHONE'] || 'Create Phone') :
                    (translateServ.dictionary['CREATE_EMAIL'] || 'Create Email') }}
                </button>
            </div>

            <p-tabView [(activeIndex)]="activeContactTabIndex">
                <p-tabPanel [header]="translateServ.dictionary['STEP_PHONES_TITLE'] || 'Phones'">
                    <p-progressSpinner *ngIf="loadingPhones[worker.UserRecID]" styleClass="mr-2" strokeWidth="4"
                        fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
                    <div *ngIf="errorPhones[worker.UserRecID]" class="p-error">{{ errorPhones[worker.UserRecID] }}</div>

                    <p-table *ngIf="!loadingPhones[worker.UserRecID] && !errorPhones[worker.UserRecID]"
                        id = "tab_worker_phu"
                        styleClass="app-data-table app-data-table--compact app-data-table--paged app-data-table--editable"
                        [value]="contactsPhones[worker.UserRecID]"
                        [paginator]="true"
                        [totalRecords] = "contactsPhones[worker.UserRecID].length"
                        [rows]="getCurrentPageSize(2, contactsPhones[worker.UserRecID].length)"
                        [rowsPerPageOptions]="setPaginator(contactsPhones[worker.UserRecID].length)"
                        (onPage) = "onRowsPerPageChange($event, 2, contactsPhones[worker.UserRecID].length)"
                        [paginatorDropdownAppendTo]="'body'"
                        [tableStyle]="{'width': '100%'}" responsiveLayout="scroll">
                        <ng-template pTemplate="header">
                            <tr>
                                <th></th>
                                <th>{{ translateServ.dictionary['JMT_COL_ID']}}</th>
                                <th>{{ translateServ.dictionary['MAINT_IN_TIT_PHONE']}}</th>
                                <th>{{ translateServ.dictionary['PHONE_TYPE']}}</th>
                                <th>{{ translateServ.dictionary['MAINT_IN_TIT_DESC']}}</th>
                                <th>{{ translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT']}}</th>
                                <th>{{ translateServ.dictionary['MAINT_IN_TIT_DATE_ENT']}}</th>
                                <th style="width: 4rem; text-align: center;">{{
                                    translateServ.dictionary['MAINT_CS_TIT_ACTIONS']}}</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-phone let-rowIndex="rowIndex">
                            <ng-container *ngIf="rowIndex === 0 && newPhoneRow[worker.UserRecID] as phoneEditRow">
                                <tr class="p-fluid">
                                    <td style="text-align: center; vertical-align: middle; width: 4rem;">
                                        <i class="pi pi-crown"
                                            [ngStyle]="{color: phoneEditRow.IsMain ? '#FFD700' : '#ccc', cursor: 'pointer', fontSize: '1.2em'}"
                                            (click)="toggleMainNewPhone(worker.UserRecID)"></i>
                                    </td>
                                    <td style="width: 5rem;"></td>
                                    <td style="min-width: 220px; max-width: 260px; vertical-align: middle;">
                                        <div class="flex align-items-center gap-2 w-full">
                                            <ng-container *ngIf="!dirServ.isRtl(); else rtlPhoneOrder">
                                                <p-autoComplete [(ngModel)]="phoneEditRow.Pref"
                                                    [suggestions]="filteredPhonePrefixes"
                                                    (completeMethod)="filterPhonePrefixes($event)"
                                                    [forceSelection]="true" [dropdown]="true" appendTo="body"
                                                    [minLength]="0" placeholder="Prefix"
                                                    styleClass="w-5rem"></p-autoComplete>
                                                <input pInputText maxlength="7" class="w-full"
                                                    [(ngModel)]="phoneEditRow.Number" placeholder="7 digits"
                                                    pattern="[0-9]{7}" />
                                            </ng-container>
                                            <ng-template #rtlPhoneOrder>
                                                <input pInputText maxlength="7" class="w-full"
                                                    [(ngModel)]="phoneEditRow.Number" placeholder="7 digits"
                                                    pattern="[0-9]{7}" />
                                                <p-autoComplete [(ngModel)]="phoneEditRow.Pref"
                                                    [suggestions]="filteredPhonePrefixes"
                                                    (completeMethod)="filterPhonePrefixes($event)"
                                                    [forceSelection]="true" [dropdown]="true" appendTo="body"
                                                    [minLength]="0" placeholder="Prefix"
                                                    styleClass="w-5rem"></p-autoComplete>
                                            </ng-template>
                                        </div>
                                    </td>
                                    <td style="min-width: 120px; max-width: 150px; vertical-align: middle;">
                                        <p-autoComplete [(ngModel)]="phoneEditRow.PhoneType"
                                            [suggestions]="filteredPhoneTypes"
                                            (completeMethod)="filterPhoneTypes($event)" [forceSelection]="true"
                                            appendTo="body" [dropdown]="true" [minLength]="0" placeholder="Type"
                                            styleClass="w-full"></p-autoComplete>
                                    </td>
                                    <td style="vertical-align: middle;">
                                        <input pInputText maxlength="50" [(ngModel)]="phoneEditRow.Description"
                                            placeholder="Description" class="w-full" />
                                    </td>
                                    <td style="text-align: center; vertical-align: middle; min-width: 100px;">
                                        <span class="p-tag"
                                            [ngClass]="phoneEditRow.IsActive ? 'p-tag-success' : 'p-tag-danger'"
                                            style="cursor:pointer;" (click)="toggleActiveNewPhone(worker.UserRecID)">
                                            {{ phoneEditRow.IsActive ?
                                            (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT'] || 'Active') :
                                            (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT'] || 'Not Active') }}
                                        </span>
                                    </td>
                                    <td style="width: 120px;"></td>
                                    <td style="text-align: center; vertical-align: middle; width: 6rem;">
                                        <div class="flex align-items-center justify-content-center gap-3">
                                            <i class="pi pi-save color-success"
                                                style="cursor: pointer; font-size: 1.2em;"
                                                (click)="onSaveNewPhone(worker.UserRecID)"></i>
                                            <i class="pi pi-trash color-danger"
                                                style="cursor: pointer; font-size: 1.2em;"
                                                (click)="onCancelNewPhone(worker.UserRecID)"></i>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                            <tr
                                *ngIf="!(editPhoneRow[worker.UserRecID] && editPhoneRow[worker.UserRecID][phone.PhoneUserRecID]); else editPhoneTemplate">
                                <td>
                                    <button pButton type="button" icon="pi pi-crown"
                                        [class.p-button-warning]="phone.IsMain" [class.p-button-text]="!phone.IsMain"
                                        class="p-button-sm" style="font-weight: 400; font-size: 1em; border-width: 1px;"
                                        [pTooltip]="phone.IsMain ? translateServ.dictionary['MAIN_PHONE'] : translateServ.dictionary['SET_AS_MAIN']"
                                        tooltipPosition="bottom"
                                        (click)="toggleContactIsMain(0, phone.PhoneUserRecID, worker.UserRecID)">
                                    </button>
                                </td>
                                <td>{{ phone.PhoneUserRecID }}</td>
                                <td>{{ phone.PhoneNumber }}</td>
                                <td style="min-width: 90px; max-width: 120px;">{{ phone.PhoneType }}</td>
                                <td>{{ phone.Descr }}</td>
                                <td>
                                    <span class="p-tag"
                                        [ngClass]="phone.IsActive == 1 ? 'p-tag-success' : 'p-tag-danger'"
                                        style="cursor: pointer;"
                                        [pTooltip]="translateServ.dictionary['TOGGLE_STATUS'] || 'Click to toggle status'"
                                        tooltipPosition="top"
                                        (click)="$event.stopPropagation(); toggleConstactActivity(0,worker.UserRecID, phone.PhoneUserRecID)">
                                        {{ phone.IsActive == 1 ? (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT']
                                        || 'Active') : (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT'] || 'Not
                                        Active') }}
                                    </span>
                                </td>
                                <td>{{ phone.DateEntered }}</td>
                                <td style="text-align: center;">
                                    <span
                                        style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 0.75em;">

                                        <button pButton icon="pi pi-pencil" class="p-button-text p-button-sm"
                                            (click)="startEditPhone(worker.UserRecID, phone)"
                                            pTooltip="{{ translateServ.dictionary['PREV_BTN_EDIT'] }}"
                                            tooltipPosition="top">
                                        </button>

                                        <button pButton icon="pi pi-trash" class="p-button-text p-button-sm"
                                            (click)="deleteContact(0, phone.PhoneUserRecID, worker.UserRecID)"
                                            pTooltip="{{ translateServ.dictionary['DELETE'] }}" tooltipPosition="top">
                                        </button>
                                    </span>
                                </td>
                            </tr>

                            <ng-template #editPhoneTemplate>
                                <tr
                                    *ngIf="editPhoneRow[worker.UserRecID] && editPhoneRow[worker.UserRecID][phone.PhoneUserRecID] as editData">
                                    <td style="text-align: center; vertical-align: middle; width: 4rem;">
                                        <i class="pi pi-crown"
                                            [ngStyle]="{color: editData.IsMain == 1 ? '#FFD700' : '#ccc', fontSize: '1.2em', cursor: 'pointer'}"
                                            (click)="editData.IsMain = editData.IsMain ? 0 : 1"></i>
                                    </td>
                                    <td>{{ phone.PhoneUserRecID }}</td>
                                    <td style="min-width: 220px; max-width: 260px; vertical-align: middle;">
                                        <div class="flex align-items-center gap-2 w-full">
                                            <ng-container *ngIf="!dirServ.isRtl(); else rtlEditPhoneOrder">
                                                <p-autoComplete [(ngModel)]="editData.Pref"
                                                    [suggestions]="filteredPhonePrefixes"
                                                    (completeMethod)="filterPhonePrefixes($event)"
                                                    [forceSelection]="true" [dropdown]="true" appendTo="body"
                                                    [minLength]="0" placeholder="Prefix"
                                                    styleClass="w-5rem"></p-autoComplete>
                                                <input pInputText maxlength="7" class="w-full"
                                                    [(ngModel)]="editData.Number" placeholder="7 digits"
                                                    pattern="[0-9]{7}" />
                                            </ng-container>
                                            <ng-template #rtlEditPhoneOrder>
                                                <input pInputText maxlength="7" class="w-full"
                                                    [(ngModel)]="editData.Number" placeholder="7 digits"
                                                    pattern="[0-9]{7}" />
                                                <p-autoComplete [(ngModel)]="editData.Pref"
                                                    [suggestions]="filteredPhonePrefixes"
                                                    (completeMethod)="filterPhonePrefixes($event)"
                                                    [forceSelection]="true" [dropdown]="true" appendTo="body"
                                                    [minLength]="0" placeholder="Prefix"
                                                    styleClass="w-5rem"></p-autoComplete>
                                            </ng-template>
                                        </div>
                                    </td>
                                    <td style="min-width: 120px; max-width: 150px; vertical-align: middle;">
                                        <p-autoComplete [(ngModel)]="editData.PhoneType"
                                            [suggestions]="filteredPhoneTypes"
                                            (completeMethod)="filterPhoneTypes($event)" [forceSelection]="true"
                                            appendTo="body" [dropdown]="true" [minLength]="0" placeholder="Type"
                                            styleClass="w-full"></p-autoComplete>
                                    </td>
                                    <td style="vertical-align: middle;">
                                        <input pInputText maxlength="50" [(ngModel)]="editData.Descr"
                                            placeholder="Description" class="w-full" />
                                    </td>
                                    <td style="text-align: center; vertical-align: middle; min-width: 100px;">
                                        <span class="p-tag"
                                            [ngClass]="editData.IsActive ? 'p-tag-success' : 'p-tag-danger'"
                                            style="cursor:pointer;"
                                            (click)="editData.IsActive = editData.IsActive ? 0 : 1">
                                            {{ editData.IsActive ?
                                            (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT'] || 'Active') :
                                            (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT'] || 'Not Active') }}
                                        </span>
                                    </td>
                                    <td>{{ phone.DateEntered }}</td>
                                    <td style="text-align: center; vertical-align: middle; width: 6rem;">
                                        <span
                                            style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 0.75em;">
                                            <i class="pi pi-save color-success"
                                                style="cursor: pointer; font-size: 1.2em;"
                                                (click)="onSaveEditPhone(worker.UserRecID, phone.PhoneUserRecID, phone.PhoneRecID)"></i>
                                            <i class="pi pi-times color-danger"
                                                style="cursor: pointer; font-size: 1.2em;"
                                                (click)="cancelEditPhone(worker.UserRecID, phone.PhoneUserRecID)"></i>
                                        </span>
                                    </td>
                                </tr>
                            </ng-template>
                        </ng-template>

                        <ng-template pTemplate="emptymessage">
                            <tr *ngIf="newPhoneRow[worker.UserRecID] as phoneEditRow" class="p-fluid">
                                <td style="text-align: center; vertical-align: middle; width: 4rem;">
                                    <i class="pi pi-crown"
                                        [ngStyle]="{color: phoneEditRow.IsMain ? '#FFD700' : '#ccc', cursor: 'pointer', fontSize: '1.2em'}"
                                        (click)="toggleMainNewPhone(worker.UserRecID)"></i>
                                </td>
                                <td style="width: 5rem;"></td>
                                <td style="min-width: 220px; max-width: 260px; vertical-align: middle;">
                                    <div class="flex align-items-center gap-2 w-full">
                                        <ng-container *ngIf="!dirServ.isRtl(); else rtlPhoneOrder">
                                            <p-autoComplete [(ngModel)]="phoneEditRow.Pref"
                                                [suggestions]="filteredPhonePrefixes"
                                                (completeMethod)="filterPhonePrefixes($event)" [forceSelection]="true"
                                                [dropdown]="true" appendTo="body" [minLength]="0" placeholder="Prefix"
                                                styleClass="w-5rem"></p-autoComplete>
                                            <input pInputText maxlength="7" class="w-full"
                                                [(ngModel)]="phoneEditRow.Number" placeholder="7 digits"
                                                pattern="[0-9]{7}" />
                                        </ng-container>
                                        <ng-template #rtlPhoneOrder>
                                            <input pInputText maxlength="7" class="w-full"
                                                [(ngModel)]="phoneEditRow.Number" placeholder="7 digits"
                                                pattern="[0-9]{7}" />
                                            <p-autoComplete [(ngModel)]="phoneEditRow.Pref"
                                                [suggestions]="filteredPhonePrefixes"
                                                (completeMethod)="filterPhonePrefixes($event)" [forceSelection]="true"
                                                [dropdown]="true" appendTo="body" [minLength]="0" placeholder="Prefix"
                                                styleClass="w-5rem"></p-autoComplete>
                                        </ng-template>
                                    </div>
                                </td>
                                <td style="min-width: 120px; max-width: 150px; vertical-align: middle;">
                                    <p-autoComplete [(ngModel)]="phoneEditRow.PhoneType"
                                        [suggestions]="filteredPhoneTypes" (completeMethod)="filterPhoneTypes($event)"
                                        [forceSelection]="true" appendTo="body" [dropdown]="true" [minLength]="0"
                                        placeholder="Type" styleClass="w-full"></p-autoComplete>
                                </td>
                                <td style="vertical-align: middle;">
                                    <input pInputText maxlength="50" [(ngModel)]="phoneEditRow.Description"
                                        placeholder="Description" class="w-full" />
                                </td>
                                <td style="text-align: center; vertical-align: middle; min-width: 100px;">
                                    <span class="p-tag"
                                        [ngClass]="phoneEditRow.IsActive ? 'p-tag-success' : 'p-tag-danger'"
                                        style="cursor:pointer;" (click)="toggleActiveNewPhone(worker.UserRecID)">
                                        {{ phoneEditRow.IsActive ?
                                        (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT'] || 'Active') :
                                        (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT'] || 'Not Active') }}
                                    </span>
                                </td>
                                <td style="width: 120px;"></td>
                                <td style="text-align: center; vertical-align: middle; width: 6rem;">
                                    <div class="flex align-items-center justify-content-center gap-3">
                                        <i class="pi pi-save color-success" style="cursor: pointer; font-size: 1.2em;"
                                            (click)="onSaveNewPhone(worker.UserRecID)"></i>
                                        <i class="pi pi-trash color-danger" style="cursor: pointer; font-size: 1.2em;"
                                            (click)="onCancelNewPhone(worker.UserRecID)"></i>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="!newPhoneRow[worker.UserRecID]">
                                <td colspan="8" class="text-center p-4">No phones found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-tabPanel>

                <p-tabPanel [header]="translateServ.dictionary['MAINT_CS_TAB_EMAILS'] || 'Emails'">
                    <p-progressSpinner *ngIf="loadingEmails[worker.UserRecID]" styleClass="mr-2" strokeWidth="4"
                        fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
                    <div *ngIf="errorEmails[worker.UserRecID]" class="p-error">{{ errorEmails[worker.UserRecID] }}</div>
                    <p-table *ngIf="!loadingEmails[worker.UserRecID] && !errorEmails[worker.UserRecID]"
                        id = "tab_worker_emu"
                        styleClass="app-data-table app-data-table--compact app-data-table--paged app-data-table--editable"
                        [value]="contactsEmails[worker.UserRecID]"
                        [paginator]="true"
                        [totalRecords] = "contactsEmails[worker.UserRecID].length"
                        [rows]="getCurrentPageSize(3, contactsEmails[worker.UserRecID].length)"
                        [rowsPerPageOptions]="setPaginator(contactsEmails[worker.UserRecID].length)"
                        (onPage) = "onRowsPerPageChange($event, 3, contactsEmails[worker.UserRecID].length)"
                        [paginatorDropdownAppendTo]="'body'"
                        [tableStyle]="{'width': '100%'}" responsiveLayout="scroll">
                        <ng-template pTemplate="header">
                            <tr>
                                <th></th>
                                <th>{{ translateServ.dictionary['JMT_COL_ID']}}</th>
                                <th>{{ translateServ.dictionary['STEP_TAB_TIT_Email']}}</th>
                                <th>{{ translateServ.dictionary['MAINT_IN_TIT_DESC']}}</th>
                                <th>{{ translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT']}}</th>
                                <th>{{ translateServ.dictionary['MAINT_IN_TIT_DATE_ENT']}}</th>
                                <th style="width: 4rem; text-align: center;">{{
                                    translateServ.dictionary['MAINT_CS_TIT_ACTIONS']}}</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-email let-rowIndex="rowIndex">
                            <ng-container *ngIf="rowIndex === 0 && newEmailRow[worker.UserRecID] as emailEditRow">
                                <tr class="p-fluid">
                                    <td style="text-align: center; vertical-align: middle; width: 4rem;">
                                        <i class="pi pi-crown"
                                            [ngStyle]="{color: emailEditRow.IsMain ? '#FFD700' : '#ccc', cursor: 'pointer', fontSize: '1.2em'}"
                                            (click)="toggleMainNewEmail(worker.UserRecID)"></i>
                                    </td>
                                    <td style="width: 5rem;"></td>
                                    <td style="vertical-align: middle;">
                                        <input pInputText type="email" maxlength="100" [(ngModel)]="emailEditRow.Email"
                                            placeholder="Email" class="w-full" />
                                    </td>
                                    <td style="vertical-align: middle;">
                                        <input pInputText maxlength="50" [(ngModel)]="emailEditRow.Description"
                                            placeholder="Description" class="w-full" />
                                    </td>
                                    <td style="text-align: center; vertical-align: middle; min-width: 100px;">
                                        <span class="p-tag"
                                            [ngClass]="emailEditRow.IsActive ? 'p-tag-success' : 'p-tag-danger'"
                                            style="cursor:pointer;" (click)="toggleActiveNewEmail(worker.UserRecID)">
                                            {{ emailEditRow.IsActive ?
                                            (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT'] || 'Active') :
                                            (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT'] || 'Not Active') }}
                                        </span>
                                    </td>
                                    <td style="width: 120px;"></td>
                                    <td style="text-align: center; vertical-align: middle; width: 6rem;">
                                        <div class="flex align-items-center justify-content-center gap-3">
                                            <i class="pi pi-save color-success"
                                                style="cursor: pointer; font-size: 1.2em;"
                                                (click)="onSaveNewEmail(worker.UserRecID)"></i>
                                            <i class="pi pi-trash color-danger"
                                                style="cursor: pointer; font-size: 1.2em;"
                                                (click)="onCancelNewEmail(worker.UserRecID)"></i>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>

                            <tr
                                *ngIf="!(editEmailRow[worker.UserRecID] && editEmailRow[worker.UserRecID][email.EmailRecID]); else editEmailTemplate">
                                <td>
                                    <button pButton type="button" icon="pi pi-crown"
                                        [class.p-button-warning]="email.IsMain" [class.p-button-text]="!email.IsMain"
                                        class="p-button-sm" style="font-weight: 400; font-size: 1em; border-width: 1px;"
                                        [pTooltip]="email.IsMain ? (translateServ.dictionary['MAIN_EMAIL'] || 'Main Email') : (translateServ.dictionary['SET_AS_MAIN'] || 'Set as main')"
                                        tooltipPosition="bottom"
                                        (click)="toggleContactIsMain(1, email.EmailUserRecID, worker.UserRecID)">
                                    </button>
                                </td>
                                <td>{{ email.EmailRecID }}</td>
                                <td>{{ email.Email }}</td>
                                <td>{{ email.Descr }}</td>
                                <td>
                                    <span class="p-tag"
                                        [ngClass]="email.IsActive == 1 ? 'p-tag-success' : 'p-tag-danger'"
                                        style="cursor: pointer;"
                                        [pTooltip]="translateServ.dictionary['TOGGLE_STATUS'] || 'Click to toggle status'"
                                        tooltipPosition="top"
                                        (click)="$event.stopPropagation(); toggleConstactActivity(1, worker.UserRecID, email.EmailRecID)">
                                        {{ email.IsActive == 1 ? (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT']
                                        || 'Active') : (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT'] || 'Not
                                        Active') }}
                                    </span>
                                </td>
                                <td>{{ email.DateEntered }}</td>
                                <td style="text-align: center;">
                                    <span
                                        style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 0.75em;">
                                        <button pButton icon="pi pi-pencil" class="p-button-text p-button-sm"
                                            (click)="startEditEmail(worker.UserRecID, email)"
                                            pTooltip="{{ translateServ.dictionary['PREV_BTN_EDIT'] }}"
                                            tooltipPosition="top">
                                        </button>
                                        <button pButton icon="pi pi-trash" class="p-button-text p-button-sm"
                                            (click)="deleteContact(1, email.EmailUserRecID, worker.UserRecID)"
                                            pTooltip="{{ translateServ.dictionary['DELETE'] }}" tooltipPosition="top">
                                        </button>
                                    </span>
                                </td>
                            </tr>

                            <ng-template #editEmailTemplate>
                                <tr
                                    *ngIf="editEmailRow[worker.UserRecID] && editEmailRow[worker.UserRecID][email.EmailRecID] as editData">
                                    <td style="text-align: center; vertical-align: middle; width: 4rem;">
                                        <i class="pi pi-crown"
                                            [ngStyle]="{color: editData.IsMain == 1 ? '#FFD700' : '#ccc', fontSize: '1.2em', cursor: 'pointer'}"
                                            (click)="editData.IsMain = editData.IsMain ? 0 : 1"></i>
                                    </td>
                                    <td>{{ email.EmailRecID }}</td>
                                    <td style="vertical-align: middle;">
                                        <input pInputText type="email" maxlength="100" [(ngModel)]="editData.Email"
                                            placeholder="Email" class="w-full" />
                                    </td>
                                    <td style="vertical-align: middle;">
                                        <input pInputText maxlength="50" [(ngModel)]="editData.Descr"
                                            placeholder="Description" class="w-full" />
                                    </td>
                                    <td style="text-align: center; vertical-align: middle; min-width: 100px;">
                                        <span class="p-tag"
                                            [ngClass]="editData.IsActive ? 'p-tag-success' : 'p-tag-danger'"
                                            style="cursor:pointer;"
                                            (click)="editData.IsActive = editData.IsActive ? 0 : 1">
                                            {{ editData.IsActive ?
                                            (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT'] || 'Active') :
                                            (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT'] || 'Not Active') }}
                                        </span>
                                    </td>
                                    <td>{{ email.DateEntered }}</td>
                                    <td style="text-align: center; vertical-align: middle; width: 6rem;">
                                        <span
                                            style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 0.75em;">
                                            <i class="pi pi-save color-success"
                                                style="cursor: pointer; font-size: 1.2em;"
                                                (click)="onSaveEditEmail(worker.UserRecID, email.EmailRecID, email.EmailRecID)"></i>
                                            <i class="pi pi-times color-danger"
                                                style="cursor: pointer; font-size: 1.2em;"
                                                (click)="cancelEditEmail(worker.UserRecID, email.EmailRecID)"></i>
                                        </span>
                                    </td>
                                </tr>
                            </ng-template>
                        </ng-template>

                        <ng-template pTemplate="emptymessage">
                            <tr *ngIf="newEmailRow[worker.UserRecID] as emailEditRow" class="p-fluid">
                                <td style="text-align: center; vertical-align: middle; width: 4rem;">
                                    <i class="pi pi-crown"
                                        [ngStyle]="{color: emailEditRow.IsMain ? '#FFD700' : '#ccc', cursor: 'pointer', fontSize: '1.2em'}"
                                        (click)="toggleMainNewEmail(worker.UserRecID)"></i>
                                </td>
                                <td style="width: 5rem;"></td>
                                <td style="vertical-align: middle;">
                                    <input pInputText type="email" maxlength="100" [(ngModel)]="emailEditRow.Email"
                                        placeholder="Email" class="w-full" />
                                </td>
                                <td style="vertical-align: middle;">
                                    <input pInputText maxlength="50" [(ngModel)]="emailEditRow.Description"
                                        placeholder="Description" class="w-full" />
                                </td>
                                <td style="text-align: center; vertical-align: middle; min-width: 100px;">
                                    <span class="p-tag"
                                        [ngClass]="emailEditRow.IsActive ? 'p-tag-success' : 'p-tag-danger'"
                                        style="cursor:pointer;" (click)="toggleActiveNewEmail(worker.UserRecID)">
                                        {{ emailEditRow.IsActive ?
                                        (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT'] || 'Active') :
                                        (translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT'] || 'Not Active') }}
                                    </span>
                                </td>
                                <td style="width: 120px;"></td>
                                <td style="text-align: center; vertical-align: middle; width: 6rem;">
                                    <div class="flex align-items-center justify-content-center gap-3">
                                        <i class="pi pi-save color-success" style="cursor: pointer; font-size: 1.2em;"
                                            (click)="onSaveNewEmail(worker.UserRecID)"></i>
                                        <i class="pi pi-trash color-danger" style="cursor: pointer; font-size: 1.2em;"
                                            (click)="onCancelNewEmail(worker.UserRecID)"></i>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="!newEmailRow[worker.UserRecID]">
                                <td colspan="7" class="text-center p-4">No emails found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-tabPanel>
            </p-tabView>
        </div>
    </p-tabPanel>
    </p-tabView>
    </td>
    </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="12" class="text-center p-4">{{ translateServ.dictionary['NO_DATA'] }}</td>
        </tr>
    </ng-template>

    </p-table>
</div>